import { call, put, takeLatest } from "redux-saga/effects";
import { eKhoiNganhActionIds } from "../../action-types/category/IKhoiNganhActions";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { khoiNganhApi } from "../../../api/category/khoiNganhApi";

export function* khoiNganhSaga() {
    yield takeLatest(eKhoiNganhActionIds.LOAD_START, loadWorker);
}

function* loadWorker() {
    const res: IBaseResponse = yield call(khoiNganhApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.category.khoiNganh.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.category.khoiNganh.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}
